"use client";

import { c as _c } from "react/compiler-runtime";
import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";
import { useConfig } from "./context";
import type { ReactNode } from "react";
export function PostHogProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const config = useConfig();
  let t1;
  let t2;
  if ($[0] !== config.hasError || $[1] !== config.isLoaded || $[2] !== config.posthogHost || $[3] !== config.posthogKey) {
    t1 = () => {
      if (!config.isLoaded || !config.posthogKey || config.hasError) {
        return;
      }
      const key = config.posthogKey;
      const host = config.posthogHost;
      const init = () => {
        posthog.init(key, {
          api_host: host,
          defaults: "2025-05-24",
          capture_pageview: "history_change",
          autocapture: true,
          loaded: _temp
        });
      };
      if (typeof requestIdleCallback !== "undefined") {
        const id = requestIdleCallback(init);
        return () => cancelIdleCallback(id);
      }
      const timer = setTimeout(init, 1000);
      return () => clearTimeout(timer);
    };
    t2 = [config.isLoaded, config.posthogKey, config.posthogHost, config.hasError];
    $[0] = config.hasError;
    $[1] = config.isLoaded;
    $[2] = config.posthogHost;
    $[3] = config.posthogKey;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== children) {
    t3 = <PHProvider client={posthog}>{children}</PHProvider>;
    $[6] = children;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(ph) {
  ph.register({
    app_section: "docs"
  });
}